import React, {
  useContext,
  useEffect,
  useCallback,
  useRef,
  useState,
} from 'react'
import { Button, makeStyles, Toolbar, Typography } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'
import { isSafari } from 'react-device-detect'
import MarketContext from '../containers/MarketContext'
import Fundamentals from '../containers/Fundamentals'
import BehaviouralAnalysis from '../containers/BehaviouralAnalysis'
import exportIcon from '../assets/images/export.svg'
import { makePDF } from '../ultils/pdfUtils'
import SpinnerIcon from '../assets/images/spinner.gif'
import { Context as PortfolioContext } from '../contexts/portfolio'
import {
  clearD3Tips,
  displayPodShow0,
  getColorFromStatus,
  sliceStringWithChar,
  waiting,
} from '../ultils/dataUtil'
import charts from '../data/relationsData'
import behaviourChartConst from '../data/behaviorAnalysisChart'
import fundamental_loading from '../assets/images/Skeletons/fundamental_loading.png'
import marketContext_loading from '../assets/images/Skeletons/marketContext_loading.png'
import behavior_loading from '../assets/images/Skeletons/behavior_loading.png'
import SearchBoxCommon from '../components/SearchBoxCommon'
import FundamentalsCreditAnalysis from '../containers/FundamentalsCreditAnalysis'
import { getCookie, setCookieHelper } from '../ultils/cookie'
import { userService } from '../services/users.services'
import { EXPIRED_SECOND } from '../constants/Cookie'
import {
  getCompanyStatusWithType,
  getTrendSymbol,
} from '../ultils/chart-d3-utils'
import NoteContext from '../containers/NoteContext'
import WhatIfScenarioAnalysis from '../containers/WhatIfScenari/WhatIfScenarioAnalysis'
import SkeletonsWhatIfArticle from '../components/SletokenWhatIfArticle'
import { Alert, TIME_SHOW_ALERT } from '../components/Alert'

const useStyles = makeStyles({
  toolbar: {
    padding: '0px 24px',
    minHeight: 'unset',
    paddingTop: 17,
    background: 'white',
    maxHeight: 60,
  },
  backToPortfolioPage: {
    '&span': {
      marginLeft: 0,
    },
  },
  lgBanner: {
    width: '100%',
    backgroundPosition: 'inherit',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    marginBottom: 30,
  },
  searchCommonContainer: {
    marginLeft: 10,
    width: 250,
  },
  headContainer: {
    paddingBottom: 17,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // borderBottom: '1px solid #DFE4EB',
    height: '100%',
    width: '100%',
  },
  headContainerActiveScroll: {
    borderBottom: 'none',
    paddingBottom: 8,
  },
  button: {
    width: 'auto',
    height: '40px',
    color: '#fff',
    backgroundColor: '#1B3963',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
    fontWeight: 600,
    maxWidth: 160,
    fontSize: 14,
    '&:hover': {
      backgroundColor: '#1B3963',
      color: '#fff',
    },
  },
  spinnerIcon: {
    width: 20,
    marginLeft: 8,
  },
  pageTitle: {
    maxWidth: '400px',
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    marginRight: 20,
    '& span': {
      fontSize: 16,
      fontWeight: 600,
      textTransform: 'capitalize',
      marginLeft: 20,
    },
    '& .statusName': {
      fontWeight: 600,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    '& .companyName': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  title: {
    padding: '20px 0px 30px 0px',
  },
  container: {
    padding: '0px 24px 0px 24px',
  },
  companyDetail: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    '& div': {
      '& span:first-child': {
        whiteSpace: 'nowrap',
        paddingRight: 7,
        color: '#5E5E5E',
        opacity: 0.6,
      },
      '& span:nth-child(2)': {
        fontWeight: 600,
        color: '#474747',
        marginTop: 10,
        minHeight: 35,
        // maxHeight: 35,
      },
    },
    '& span': {
      whiteSpace: 'nowrap',
      fontSize: 14,
      '& span': {
        fontWeight: 400,
        color: '#fff',
      },
    },
    '& .MuiButton-outlinedPrimary:hover': {
      backgroundColor: '#1B3963',
      color: '#fff',
    },
  },
  breadcrumb: {
    color: '#1B3963',
    '& .MuiBreadcrumbs-li': {
      fontSize: 12,
      '& p': {
        fontSize: 12,
      },
    },
  },
  exportBtn: {
    display: 'flex',
    alignItems: 'center',
    color: '#1B3963',
    padding: '7px 10px',
    background: '#fff',
    border: '1px solid #DFE4EB',
    borderRadius: 3,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    '& img': {
      marginRight: 7,
      width: 14,
      color: '#474747',
    },
  },
  exportBar: {
    padding: '17px 24px 10px 24px',
    display: ' flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  exportBarActiveScroll: {
    position: 'sticky',
    top: 56,
    zIndex: 1,
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
    padding: '17px 24px 17px 24px',
    background: '#F5F8FF',
  },
  exportBarItem: {
    display: 'inline-grid',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    marginRight: 15,
  },
  headSectionList: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  jumpItem: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: 'black',
    '@media only screen and (min-width: 1200px)': {
      marginRight: 10,
    },
    '@media only screen and (min-width: 1500px)': {
      marginRight: 32,
    },
  },
  activeLink: {
    '& div': {
      color: '#3393F3',
    },
  },
  scrollHead: {
    position: 'sticky',
    top: 0,
    background: '#F5F8FF',
    zIndex: 2,
  },
  activeScrollHead: {
    background: '#FFFFFF',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
  },
  spinnerContainer: {
    width: '100%',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toolbarActiveScroll: {
    position: 'sticky',
    top: 0,
    background: 'white',
    zIndex: 9,
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
    paddingTop: 8,
  },
  jumpItemActive: {
    color: '#3393F3',
  },
  status: {
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    '& div': {
      fontWeight: 600,
      marginLeft: 10,
    },
  },
  circle: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    position: 'relative',
    '& > div': {
      height: 16,
      width: 16,
      opacity: '0.35',
      borderRadius: '50%',
      position: 'absolute',
      left: '-4px',
      top: '-4px',
      margin: 0,
      'animation-name': `$backgroundColorPalette`,
      'animation-duration': '1s',
      'animation-iteration-count': 'infinite',
      'animation-direction': 'alternate',
      'animation-timing-function': 'liner',
    },
  },
  '@keyframes backgroundColorPalette': {
    '0%': {
      opacity: 0.25,
    },
    '25%': {
      opacity: 0.45,
    },
    '50%': {
      opacity: 0.55,
    },
    '75%': {
      opacity: 0.45,
    },
    '100%': {
      opacity: 0.25,
    },
  },
  divStatusHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '25px',
  },
  showStatusHeader: {
    color: '#1B3963',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    // marginTop: 10,
    '& img': {
      color: '#474747',
    },
  },
  sectionWhatIf: {
    padding: '26px 20px 20px 30px',
    marginBottom: '20px',
    background: 'white',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    boxSizing: 'border-box',
  },
})

const CompanyPage = () => {
  const classes = useStyles()
  const {
    state,
    cleanUp,
    addTickers,
    getPrices,
    getEvents,
    getTickersOnlyInPortfolio,
    getAllTickersInUniverse,
    getScanCharts,
    getBehaviourAnalysisChartData,
    getCreditSeries,
    getNotes,
    getWhatIf,
  } = useContext(PortfolioContext)
  const [companyInfo, setCompanyInfo] = useState<any>({})
  const [isLoading, setIsLoading] = useState(false)
  const [isStartScrolling, setIsStartScrolling] = useState(false)
  const [color, setColor] = useState('')
  const [activeTabScroll, setActiveTabScroll] = useState('#risk')
  const headerRef = useRef<any>(null)
  const riskRef = useRef<any>(null)
  const fundamentalsRef = useRef<any>(null)
  const behaviouralRef = useRef<any>(null)
  const creditAnalysisRef = useRef<any>(null)
  const [recent, setRecent] = useState<any>([])
  const [flagGetCompanyData, setFlagGetCompanyData] = useState<boolean>(false)
  const [clickExport, setClickExport] = useState<boolean>(false)
  const history = useHistory()
  // const companies = useMemo(() => [...recent, ...companySearchList], [
  //   recent,
  //   companySearchList,
  // ])

  const onHandleScroll = (evt: any) => {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop
    setIsStartScrolling(scrollPosition !== 0)
    if (scrollPosition >= 0 && scrollPosition < 600) {
      setActiveTabScroll('#risk')
    } else if (scrollPosition >= 600 && scrollPosition < 1000) {
      setActiveTabScroll('#fundamental')
    } else if (scrollPosition >= 1000 && scrollPosition < 1200) {
      setActiveTabScroll('#fundamentalCreditAnalysis')
    } else {
      setActiveTabScroll('#behavioural')
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', onHandleScroll)
    return () => window.removeEventListener('scroll', onHandleScroll)
  }, [])

  useEffect(() => {
    if (clickExport) {
      setTimeout(() => {
        printDocument()
      }, 900)
      setClickExport(false)
    }
  }, [clickExport])

  const tickerId = window.location.pathname.split('/')[2]
    ? window.location.pathname.split('/')[2]
    : 'RVA.AU'

  const companyExistedInPortfolio = React.useMemo(
    () => state.tickersInPortfolio.map((i: any) => i.ticker).includes(tickerId),
    [state.tickersInPortfolio, tickerId],
  )

  const printDocument = async () => {
    const ignoreElementItems = [
      'headSectionList',
      'exportToPdfBtn',
      'filterByBox',
      ...charts.map(c => `expandChartBtn-chart-${c.id}`),
      ...behaviourChartConst.map(
        c => `expandBehaviorAnalysisChartBtn-${c.title}`,
      ),
    ]
    setIsLoading(true)
    await makePDF(
      'companyPage',
      `${tickerId}_report_${new Date().toDateString()}`,
      ignoreElementItems,
    )
    setIsLoading(false)
  }

  useEffect(() => {
    clearD3Tips()
  }, [])

  const getDirectUrl = (path: string) => {
    return window.location.pathname + path
  }

  const addToPortfolio = () => {
    const userId = getCookie('userId')
    addTickers(userId, tickerId)
  }

  const getAllTickersInUniverses = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInUniverse ||
        (Array.isArray(state?.tickersInUniverse) &&
          state?.tickersInUniverse.length === 0)
      ) {
        getAllTickersInUniverse(userId)
      }
    },
    [state?.tickersInUniverse],
  )

  const getTickersOnlyInPortfolios = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInPortfolio ||
        (Array.isArray(state?.tickersInPortfolio) &&
          state?.tickersInPortfolio.length === 0)
      ) {
        getTickersOnlyInPortfolio(userId)
      }
    },
    [state?.tickersInPortfolio],
  )

  const getCompanyData = async (
    tickerId: string,
    fromDate: string,
    toDate: string,
    userId: string,
  ) => {
    getTickersOnlyInPortfolios(userId)
    getNotes(tickerId, userId)
    getWhatIf(tickerId, userId)
    getScanCharts(tickerId, userId)
    getBehaviourAnalysisChartData(userId, tickerId, fromDate, toDate)
    getPrices(tickerId, fromDate, toDate, userId)
    getEvents(tickerId, userId)
    getCreditSeries(userId, tickerId, fromDate, toDate)
  }

  useEffect(() => {
    const fetchingMarketContextData = async () => {
      await cleanUp()
      const fromDate = '2017-01-03'
      const toDate = '2030-01-01'
      if (!getCookie('userId')) {
        userService
          .getUser(getCookie('email'))
          .then(async res => {
            setCookieHelper('userId', res.data, EXPIRED_SECOND)
            const userId = res.data
            getAllTickersInUniverses(userId)
            getCompanyData(tickerId, fromDate, toDate, userId)
          })
          .catch(() => {})
      } else {
        const userId = getCookie('userId')
        getAllTickersInUniverses(userId)
        getCompanyData(tickerId, fromDate, toDate, userId)
      }
    }
    fetchingMarketContextData()
  }, [tickerId])

  useEffect(() => {
    if (state.tickersInUniverse.length > 0) {
      let data = state.tickersInUniverse.filter(
        (item: any) => item.ticker === tickerId,
      )[0]
      if (data) {
        setFlagGetCompanyData(true)
        setCompanyInfo(data)
        setColor(getColorFromStatus(data.status))
      } else {
        const showContentNotFound = async () => {
          Alert.info(
            'This company is currently not available in our coverage. Navigating back to the portfolio page',
          )
          await waiting(TIME_SHOW_ALERT)
          history.push('/portfolio')
        }
        showContentNotFound()
      }
    }
  }, [state.tickersInUniverse, tickerId])

  const onHandleJump = (thisIdLink: any) => {
    setActiveTabScroll(thisIdLink)
  }

  const backToPortfolioPage = () => {
    history.push('/portfolio')
  }

  const showImpliedRating = getCookie('implied_rating_flag') !== 'False'

  return (
    <>
      <div id="companyPage">
        <Toolbar
          ref={headerRef}
          className={`${classes.toolbar} ${
            isStartScrolling ? classes.toolbarActiveScroll : ''
          }`}
        >
          <div
            className={`${classes.headContainer} ${
              isStartScrolling ? classes.headContainerActiveScroll : ''
            }`}
          >
            <Typography component="div" className={classes.pageTitle}>
              <div className="companyName">{companyInfo?.proper_name}</div>
            </Typography>
            <div id="headSectionList" className={classes.headSectionList}>
              <a
                onClick={() => onHandleJump('#risk')}
                href={getDirectUrl('#risk')}
              >
                <div
                  className={`${classes.jumpItem} ${
                    activeTabScroll === '#risk' ? classes.jumpItemActive : ''
                  }`}
                  style={{ minWidth: '80px' }}
                >
                  Risk Events
                </div>
              </a>
              {state.showFundamentals && (
                <a
                  href={getDirectUrl('#fundamental')}
                  onClick={() => onHandleJump('#fundamental')}
                >
                  <div
                    className={`${classes.jumpItem} ${
                      activeTabScroll === '#fundamental'
                        ? classes.jumpItemActive
                        : ''
                    }`}
                  >
                    Fundamentals
                  </div>
                </a>
              )}
              {state.showCreditChart && (
                <a
                  href={getDirectUrl('#fundamentalCreditAnalysis')}
                  onClick={() => onHandleJump('#fundamentalCreditAnalysis')}
                >
                  <div
                    className={`${classes.jumpItem} ${
                      activeTabScroll === '#fundamentalCreditAnalysis'
                        ? classes.jumpItemActive
                        : ''
                    }`}
                  >
                    Credit Analysis
                  </div>
                </a>
              )}
              {state.showBehavioural && (
                <a
                  href={getDirectUrl('#behavioural')}
                  onClick={() => onHandleJump('#behavioural')}
                >
                  <div
                    className={`${classes.jumpItem} ${
                      activeTabScroll === '#behavioural'
                        ? classes.jumpItemActive
                        : ''
                    }`}
                    style={{ minWidth: '136px' }}
                  >
                    Behavioural Analysis
                  </div>
                </a>
              )}
              {!companyExistedInPortfolio && (
                <Button
                  onClick={addToPortfolio}
                  startIcon={<Add />}
                  className={classes.button}
                  variant="outlined"
                  color="primary"
                >
                  Add to portfolio
                </Button>
              )}
              <div className={classes.searchCommonContainer}>
                <SearchBoxCommon searchList={state.tickersInUniverse} />
              </div>
            </div>
          </div>
        </Toolbar>

        <div
          className={`${classes.exportBar} ${
            isStartScrolling ? classes.exportBarActiveScroll : ''
          }`}
        >
          <div className={classes.companyDetail}>
            <div className={classes.exportBarItem}>
              <span>Ticker</span>
              <span>{companyInfo?.ticker}</span>
            </div>
            {showImpliedRating && (
              <div className={classes.exportBarItem}>
                <span>Rating</span>
                <span>
                  {companyInfo?.ticker && (
                    <>
                      {companyInfo.bfaiRating ? companyInfo?.bfaiRating : 'N/A'}
                      {getTrendSymbol(companyInfo.rating_trend)}
                    </>
                  )}
                </span>
              </div>
            )}
            <div className={classes.exportBarItem}>
              <span>Industry</span>
              <span>{companyInfo?.industry}</span>
            </div>
            <div className={classes.exportBarItem}>
              <span>Credit Stress Measure</span>
              <span>
                {companyInfo?.ticker && displayPodShow0(companyInfo?.pod)}
              </span>
            </div>
            <div className={classes.exportBarItem}>
              <span>Credit Risk</span>
              <span>
                {companyInfo?.credit_status && (
                  <div className={classes.showStatusHeader}>
                    <div className={classes.status}>
                      <div
                        className={classes.circle}
                        style={{
                          backgroundColor: getColorFromStatus(
                            companyInfo?.credit_status,
                          ),
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: getColorFromStatus(
                              companyInfo?.credit_status,
                            ),
                          }}
                        />
                      </div>
                      <div
                        style={{
                          color: getColorFromStatus(companyInfo?.credit_status),
                        }}
                        className="statusName"
                      >
                        {getCompanyStatusWithType(
                          companyInfo?.credit_status,
                          'Credit',
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </span>
            </div>
            <div className={classes.exportBarItem}>
              <span>Equity Risk</span>
              <span>
                {companyInfo?.status && (
                  <div className={classes.showStatusHeader}>
                    <div className={classes.status}>
                      <div
                        className={classes.circle}
                        style={{
                          backgroundColor: getColorFromStatus(
                            companyInfo?.status,
                          ),
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: getColorFromStatus(
                              companyInfo?.status,
                            ),
                          }}
                        />
                      </div>
                      <div
                        style={{
                          color: getColorFromStatus(companyInfo?.status),
                        }}
                        className="statusName"
                      >
                        {getCompanyStatusWithType(
                          companyInfo?.status,
                          'Equity',
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </span>
            </div>
            <div className={classes.exportBarItem}>
              <span>Date on Watchlist</span>
              <span>{companyInfo?.equity_risk_trigger_date}</span>
            </div>
          </div>
          {!isSafari && (
            <Button
              disabled={isLoading}
              id="exportToPdfBtn"
              className={classes.exportBtn}
              onClick={() => {
                if (window.scrollY === 0) {
                  printDocument()
                } else {
                  window.scrollTo({ top: -100, left: 0, behavior: 'smooth' })
                  setIsStartScrolling(false)
                  setActiveTabScroll('#risk')
                  setClickExport(true)
                }
              }}
            >
              <img alt="" src={exportIcon} />
              Export to PDF
              {!!isLoading && (
                <img
                  alt="spinner"
                  src={SpinnerIcon}
                  className={classes.spinnerIcon}
                />
              )}
            </Button>
          )}
        </div>

        <div className={classes.container}>
          {!state.notesDataLoading && state?.notesData?.signal_overview && (
            <div id="notes" ref={riskRef}>
              <NoteContext tickerId={tickerId} />
            </div>
          )}
          {state.marketContext.eventLoading ||
          state.marketContext.priceLoading ? (
            <div
              className={classes.lgBanner}
              style={{
                backgroundImage: `url(${marketContext_loading})`,
                height: 625,
              }}
            />
          ) : (
            <div id="risk" ref={riskRef}>
              <MarketContext
                tickerId={tickerId}
                riskStatus={{
                  color: getColorFromStatus(companyInfo?.status),
                  text: getCompanyStatusWithType(companyInfo?.status, 'Equity'),
                }}
              />
            </div>
          )}

          {state.fundamentalLoading ? (
            <div
              className={classes.lgBanner}
              style={{
                backgroundImage: `url(${fundamental_loading})`,
                height: 840,
              }}
            />
          ) : (
            state.showFundamentals && (
              <div id="fundamental" ref={fundamentalsRef}>
                <Fundamentals tickerId={tickerId} />
              </div>
            )
          )}

          {!state.creditLoading &&
            !state?.marketContext?.priceLoading &&
            !state?.marketContext?.eventLoading &&
            state.showCreditChart && (
              <div id="fundamentalCreditAnalysis" ref={creditAnalysisRef}>
                <FundamentalsCreditAnalysis
                  companyInfo={companyInfo}
                  riskStatus={{
                    color: getColorFromStatus(companyInfo?.credit_status),
                    text: getCompanyStatusWithType(
                      companyInfo?.credit_status,
                      'Credit',
                    ),
                  }}
                />
              </div>
            )}

          <div id="whatIf">
            {state?.whatIfLoading && (
              <div className={classes.sectionWhatIf}>
                <SkeletonsWhatIfArticle />
              </div>
            )}
            {!state?.whatIfLoading &&
              state?.whatIfDataDetail?.scenario_1_fields && (
                <WhatIfScenarioAnalysis />
              )}
          </div>

          {state.behaviorChartLoading ? (
            <div
              className={classes.lgBanner}
              style={{
                backgroundImage: `url(${behavior_loading})`,
                height: 400,
              }}
            />
          ) : (
            state.showBehavioural && (
              <div id="behavioural" ref={behaviouralRef}>
                <BehaviouralAnalysis tickerId={tickerId} />
              </div>
            )
          )}
        </div>
      </div>
    </>
  )
}

export default CompanyPage
